export { default } from './Pin'
